import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-danvi-branding',
  templateUrl: './danvi-branding.component.html',
  styleUrls: ['./danvi-branding.component.scss']
})
export class DanviBrandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
